export const pricingHero = {
  title: "Simple, self-serve pricing",
  subtitle: "£10 for 10 minutes — no appointment needed",
};

export const pricingTiers = [
  {
    name: "Self-serve wash",
    price: "£10",
    duration: "10 minutes",
    description: "One flat rate for full access to the station.",
    includes: [
      "10 minutes of washing time",
      "Shampoo, warm rinse, and conditioner",
      "Anti-flea rinse and blow dry",
      "Tub disinfect after use",
      "Card payment only",
    ],
  },
];

export const pricingNote =
  "Payment by card only at the station. Prices may vary by location — check your nearest station on the home page.";

export const pricingMeta = {
  title: "Pricing | Pawwash",
  description:
    "Self-serve dog wash for £10 per 10 minutes. Card payment only — open 24/7 at participating Glasgow locations.",
  path: "/pricing",
};
